import { Fragment } from "react";
import Headings from "@usas/ui-web/components/headings/Headings";
import useMemberCompetitionCategory from "./UseMemberCompetitionCategory";
import CompetitionCategoryRadiobuttonList from "@usas/ui-web/components/radiobuttonlists/competitionCategoryRadiobuttonList/CompetitionCategoryRadiobuttonList";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

const MemberCompetitionCategoryInfo = () => {
  const {
    Constants,
    basePersonState,
    formState,
    errorState,
    competitionGenderState,
    onFormValueChanged,
    handleSubmit,
    resetForm
  } = useMemberCompetitionCategory();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">          
          <Headings.H3>Member Official Competition Category Change</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className={"col-xs-12 col-sm-6 col-md-4"}>
            <CompetitionCategoryRadiobuttonList
              label="Competition Category*"
              name="competitionGenderTypeId"
              isVertical={false}
              value={Number(formState.competitionGenderTypeId)}
              error={errorState.competitionGenderTypeId}
              message={errorState.competitionGenderTypeId}
              onChange={(value) => { onFormValueChanged('competitionGenderTypeId', Number(value)); }}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker
              label="Competition Category Change Date*"
              name="competitionCategoryChangeDate"
              value={formState.competitionCategoryChangeDate}
              error={errorState.competitionCategoryChangeDate}
              message={errorState.competitionCategoryChangeDate}
              onChange={(value) => { onFormValueChanged('competitionCategoryChangeDate', value); }} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={resetForm}>Cancel</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={basePersonState.isObjLoading || competitionGenderState.isArrayLoading} />
      {/* <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={basePersonState.isSaving} /> */}
    </Fragment>
  );
}; 

export default MemberCompetitionCategoryInfo;